import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../styles/projectsSection/projectsSection.min.css';

const projectsImage = '/images/projects-image.png';
const globeImage = '/images/globe-image.png'; // Update with correct path

const Projects = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/projetos');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
        <Container fluid className='p-0 projects-description-container section-separator'>
            {/* Image Section */}
            <div className='projects-image-container'>
                <img src={projectsImage} className='p-0 w-100' alt='Y4C Project' />
            </div>


            {/* Projects Content */}
            <Container className='projects-content py-5 position-relative'>
            {/* Globe Image - Only visible on large screens */}
            <div className='globe-container d-none d-md-block'>
                <img src={globeImage} alt='Globe' className='globe-image' />
            </div>
                <Row className='justify-content-center'>
                    <Col md={4}>
                        <h2 className='text-white text-uppercase fw-bold mb-4 display-5'>Projetos</h2>
                    </Col>
                </Row>

                <Row className='justify-content-end text-white align-items-start projects-column'>
                    {/* Left Column - Nacionais */}
                    <Col md={4} className='text-start'>
                        <h3 className='fw-bold text-uppercase mb-4'>Nacionais</h3>
                        <p className='projects-description'>
                            Capacitamos jovens em Portugal através de Formações, Sessões de Sensibilização, Voluntariado, promovendo uma cidadania e participação ativa por parte dos jovens.
                        </p>
                        <div className='w-100 d-flex justify-content-end project-description-btn fw-bold'>
                            <button type='button'className='rounded-pill px-4 py-2 fw-bold main-btn projects-btn' onClick={handleClick}>Saber +</button>
                        </div>
                    </Col>

                    {/* Right Column - Internacionais */}
                    <Col md={4} className='text-start mt-4 mt-md-0 h-100'>
                        <h3 className='fw-bold text-uppercase mb-4'>Internacionais</h3>
                        <p className='projects-description'>
                            Proporcionamos Intercâmbios, Formações e Voluntariado através do Erasmus+, desenvolvendo competências e ampliando horizontes a nível global.
                        </p>
                        <div className='w-100 d-flex justify-content-end project-description-btn fw-bold'>
                            <button type='button' className='rounded-pill px-4 py-2 fw-bold main-btn projects-btn' onClick={handleClick}>Saber +</button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Projects;
